interface HeroProps {
  onGetOffer: () => void;
}

export default function Hero({ onGetOffer }: HeroProps) {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://readdy.ai/api/search-image?query=Modern%20luxury%20residential%20neighborhood%20aerial%20view%20with%20beautiful%20houses%20and%20green%20lawns%20under%20clear%20blue%20sky%20professional%20real%20estate%20photography%20bright%20natural%20lighting%20clean%20suburban%20streets%20with%20trees%20and%20well-maintained%20properties%20showing%20peaceful%20American%20residential%20community&width=1920&height=1080&seq=hero-bg-001&orientation=landscape"
          alt="Real Estate Properties"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center text-white pt-28 md:pt-16 pb-16">
        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight">
          Sell Your House Fast<br />
          <span className="text-emerald-400">For Cash</span>
        </h1>
        <p className="text-lg md:text-2xl mb-4 text-gray-100 max-w-3xl mx-auto">
          Nationwide Real Estate Solutions - No Repairs, No Fees, No Hassle
        </p>
        <p className="text-base md:text-xl mb-10 text-gray-200 max-w-2xl mx-auto">
          Get a fair cash offer within 24 hours. We buy houses in any condition, anywhere in the United States.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button 
            onClick={onGetOffer}
            className="bg-emerald-600 text-white px-10 py-4 rounded-lg text-lg font-semibold hover:bg-emerald-700 transition-all transform hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer"
          >
            Get Your Free Cash Offer
          </button>
          <a 
            href="#how-it-works"
            className="bg-white/10 backdrop-blur-sm text-white px-10 py-4 rounded-lg text-lg font-semibold hover:bg-white/20 transition-all border-2 border-white/30 whitespace-nowrap cursor-pointer"
          >
            Learn How It Works
          </a>
        </div>

        {/* Trust Indicators */}
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
            <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3">
              <i className="ri-time-line text-4xl text-emerald-400"></i>
            </div>
            <h3 className="text-2xl font-bold mb-2">24-Hour Offers</h3>
            <p className="text-gray-200 text-sm">Fast cash offers with no waiting</p>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
            <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3">
              <i className="ri-map-pin-line text-4xl text-emerald-400"></i>
            </div>
            <h3 className="text-2xl font-bold mb-2">Nationwide Service</h3>
            <p className="text-gray-200 text-sm">We buy homes in all 50 states</p>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
            <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3">
              <i className="ri-shield-check-line text-4xl text-emerald-400"></i>
            </div>
            <h3 className="text-2xl font-bold mb-2">No Fees or Commissions</h3>
            <p className="text-gray-200 text-sm">Keep 100% of your cash offer</p>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <a href="#about" className="cursor-pointer">
          <i className="ri-arrow-down-line text-3xl text-white animate-bounce"></i>
        </a>
      </div>
    </section>
  );
}
